import OriginDatePicker from './DatePicker';

export type DatePickerProps = typeof OriginDatePicker & {};
const DatePicker = OriginDatePicker as DatePickerProps;

export { DatePicker };

export { default as DateRangePicker } from './RangePicker';
